import { REQUEST_PROFILE_HEADER_FOOTER_ACTION } from '../RequestProfileHeaderFooter'

export const REQUEST_PROFILE_ACTIONS_WIDGET_ACTION = {
  addNew: 'addNew',
  archive: 'archive',
  attachedRequests: 'attachedRequests',
  back: 'back',
  markAsUnread: 'markAsUnread',
  restore: 'restore',
  toggleVisibleToDwellers: 'toggleVisibleToDwellers',
}

export const REQUEST_PROFILE_ACTIONS_WIDGET_ATTACHED_REQUESTS_OPTION = {
  attach: 'attach',
  create: 'create',
  massEdit: 'massEdit',
}

export const REQUEST_PROFILE_ACTIONS_WIDGET_NOTIFICATION_TITLE_KEY = {
  archive: 'RequestProfile.ArchivedSuccessKey',
  connectRequests: 'RequestProfile.RequestsConnectedSuccessKey',
  hideForDwellers: 'RequestProfile.HiddenForDwellersSuccessKey',
  markAsUnread: 'RequestProfile.MarkedAsUnreadSuccessKey',
  restore: 'RequestProfile.RestoredSuccessKey',
  showForDwellers: 'RequestProfile.ShownForDwellersSuccessKey',
}

export const REQUEST_PROFILE_ACTIONS_WIDGET_ADD_NEW_OPTION_LABEL_KEY = {
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.activity]:
    'RequestProfile.ActionsWidgetAddNewActivityKey',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.chat]:
    'RequestProfile.ActionsWidgetAddNewChatKey',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.docFlow]:
    'RequestProfile.ActionsWidgetAddNewDocFlowKey',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.email]:
    'RequestProfile.ActionsWidgetAddNewEmailKey',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.folder]:
    'RequestProfile.ActionsWidgetAddNewFolderKey',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.invoice]:
    'RequestProfile.ActionsWidgetAddNewInvoiceKey',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.post]:
    'RequestProfile.ActionsWidgetAddNewPostKey',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.serviceRequest]:
    'RequestProfile.ActionsWidgetAddNewServiceRequestKey',
  [REQUEST_PROFILE_HEADER_FOOTER_ACTION.upload]:
    'RequestProfile.ActionsWidgetAddNewDocumentKey',
}
